import { useCreateGeneralAnnotation } from '../hooks/useCreateGeneralAnnotation'
import styles from './DutyAnnotationTooltip.module.scss'
import { ControlSheetAnnotation, ControlSheetNote } from '../types/types'
import { ControlSheetNotes } from './ControlSheetNotes'
import { annotationMapper } from '../helpers/annotationMapper'

interface DutyAnnotationTooltipProps {
    duty: string
    trip: string
    run: string
    route: string
    addTempNote: (note: ControlSheetNote) => void
    deleteTempNote: (noteId: string) => void
    addTempAnnotation: (annotation: ControlSheetAnnotation) => void
    onUpdate: () => void
    annotationId?: string
    existingNotes: ControlSheetNote[]
}

export const DutyAnnotationTooltip = (props: DutyAnnotationTooltipProps) => {
    const {
        duty,
        trip,
        run,
        route,
        addTempNote,
        deleteTempNote,
        addTempAnnotation,
        onUpdate,
        annotationId,
        existingNotes,
    } = props

    const {
        handleCreateGeneralAnnotationAsync,
        // isPending: isCreateAnnotationPending,
        // data: createAnnotationData,
        // error: createAnnotationError,
    } = useCreateGeneralAnnotation()

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.headerTitle}>Duty {duty}</span>
                <span className={styles.headerSubtitle}>
                    Trip {trip} Run {run}
                </span>
            </div>
            <ControlSheetNotes
                createAnnotation={async () => {
                    const annotation = await handleCreateGeneralAnnotationAsync(duty, trip, run, route)
                    if (annotation) {
                        return annotationMapper()(annotation)
                    }
                    throw new Error('Failed to create annotation')
                }}
                annotationId={annotationId}
                existingNotes={existingNotes}
                addTempNote={addTempNote}
                deleteTempNote={deleteTempNote}
                addTempAnnotation={addTempAnnotation}
                onUpdate={onUpdate}
            />
        </div>
    )
}
